export const handleURLImage = (url) => {
    return url.response.url
}